"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Space = void 0;
const PIXI = __importStar(require("pixi.js"));
const module_abstract_1 = require("@kennethgomez/module/module.abstract");
const event_enum_1 = require("@kennethgomez/events/event.enum");
const events_1 = require("@kennethgomez/events/events");
const landing_view_1 = require("@kennethgomez/canvas/space/views/landing-view");
const init_stars_ticker_1 = require("../ticker/space/star/init-stars/init-stars-ticker");
const hovering_controller_1 = require("./controllers/hovering-controller/hovering-controller");
const start_view_1 = require("./views/start-view/start-view");
const star_1 = require("./star/star");
class Space extends module_abstract_1.Module {
    /**
     * Amount of star per pixel²
     */
    static STAR_RATIO = 0.008;
    _stars;
    _container;
    constructor() {
        super([
            new start_view_1.StartView(),
            new landing_view_1.LandingView(),
            new hovering_controller_1.HoveringController(),
        ]);
        this._stars = [];
        this._container = new PIXI.Container();
        this._container.interactive = true;
        this._container.interactiveChildren = false;
        this._container.on('pointermove', (e) => events_1.Events.emit(event_enum_1.Event.SPACE_POINTER_MOVE, { base: e }));
        window.addEventListener('mouseout', this._onMouseOut);
        window.addEventListener('touchend', this._onMouseOut);
    }
    onInit() {
        this._populateStars();
        this._drawSpace();
        events_1.Events.emit(event_enum_1.Event.ADD_TICKER, { ticker: new init_stars_ticker_1.InitStarsTicker(this._stars) });
        events_1.Events.on(event_enum_1.Event.SPACE_INITIALIZED, this._onSpaceInitialized, this);
        events_1.Events.on(event_enum_1.Event.START_BUTTON_CLICK, this._onStart, this);
    }
    onDispose() {
        this._container.destroy({ children: true });
        window.removeEventListener('mouseout', this._onMouseOut);
        window.removeEventListener('touchend', this._onMouseOut);
    }
    addChild(...objects) {
        this._container.addChild(...objects);
    }
    _onSpaceInitialized() {
        this.startView.start();
        this.hoveringController.start();
    }
    _onStart() {
        const stars = this.startView.focusController.nearStartButtonStars;
        this.startView.dispose();
        events_1.Events.removeListener(event_enum_1.Event.START_BUTTON_CLICK, this._onStart, this);
        this.landingView.start(stars);
    }
    _onMouseOut(e) {
        events_1.Events.emit(event_enum_1.Event.SPACE_POINTER_OUT, { base: e });
    }
    _populateStars() {
        const { innerWidth, innerHeight } = window;
        // We multiply by devicePixelRatio to keep the same ratio even with screen zoom
        const spaceSize = innerWidth * innerHeight * Space.STAR_RATIO * window.devicePixelRatio;
        for (let i = 0; i < spaceSize; i++) {
            const star = star_1.Star.random();
            this._stars.push(star);
        }
    }
    _drawSpace() {
        this._container.addChild(...this._stars.map((s) => s.sprite));
    }
    get startView() {
        return this.getSubmodule(start_view_1.StartView);
    }
    get landingView() {
        return this.getSubmodule(landing_view_1.LandingView);
    }
    get hoveringController() {
        return this.getSubmodule(hovering_controller_1.HoveringController);
    }
    get container() {
        return this._container;
    }
    get stars() {
        return this._stars;
    }
}
exports.Space = Space;
